import type { CategoryDef, StatDef } from '../types';

export const CATEGORIES: CategoryDef[] = [
  { id: 'hull',    label: 'Species', keys: ['wolf','dragon','slime','bird','golem'] },
  { id: 'cranium', label: 'Cranium', keys: ['horns','antlers','third_eye','crystal'], optional: true },
  { id: 'back',    label: 'Back',    keys: ['bat_wings','feathered_wings','spikes','shell'], optional: true },
  { id: 'tail',    label: 'Tail',    keys: ['lizard','wolf_tail','scorpion','spectral'], optional: true },
  { id: 'world',   label: 'World',   keys: ['forest','volcano','underwater','void','clouds'] },
];

export const STAT_DEFS: StatDef[] = [
  { id: 'ferocity',   label: 'Ferocity',   max: 100, iconKey: 'flame',  color: '#f97316' },
  { id: 'agility',    label: 'Agility',    max: 100, iconKey: 'wind',   color: '#22d3ee' },
  { id: 'arcane',     label: 'Arcane',     max: 100, iconKey: 'eye',    color: '#a855f7' },
  { id: 'resilience', label: 'Resilience', max: 100, iconKey: 'shield', color: '#3b82f6' },
  { id: 'stealth',    label: 'Stealth',    max: 100, iconKey: 'star',   color: '#94a3b8', hidden: true },
];
